import { useQuery } from "@apollo/client/react";import React, { useEffect, useState } from "react";

import { Box } from "@mui/material";
import { CustomDialog } from "../../../../../components/customDialog/CustomDialog";
import DataGridGenerico from "../../../../../components/dataGrid/DataGridGenerico";
import { GET_INDICACION_HISTORIAL } from "../../../../../data/graphQL/queries/GestionAsistencial/getIndicacionHistorial";
import { TabIndicacionFields } from "./TabIndicacionFields";
import { useTabIndicationAddIndicacionFields } from "../../hooks/TabIndicacion/useTabIndicationAddIndicacionFields";
import { useTabIndicacionHistorialColumns } from "../../hooks/TabIndicacion/useTabIndicacionHistorialColumns";

export function TabIndicacionHistoryDialog({
  open,
  handleCloseDialog,
  idEvaluacion,
  evaluacionSelected
}) {
  const { fechaDesde, fechaHasta } = evaluacionSelected;
  const [rows, setRows] = useState([]);
  const [formValues, setFormValues] = useState({
    fechaDesde,
    fechaHasta,
    insumo: "",
    cantidad: 0,
    idUnidad: 0
  });

  const handleChange = (name, value) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const applyClientSideFilters = (data) => {
    const inputBuscar = formValues?.insumo?.trim().toUpperCase();

    if (!inputBuscar) return data;

    const dataFiltered = data.filter((ins) => {
      const idIndicacion = ins.idIndicacion.toString().toUpperCase();
      const insumo = ins.insumo.toString().toUpperCase();

      return idIndicacion.includes(inputBuscar) || insumo.includes(inputBuscar);
    });

    return dataFiltered;
  };

  const { data: historial, loading } = useQuery(GET_INDICACION_HISTORIAL, {
    fetchPolicy: "no-cache",
    variables: {
      input: {
        idEvaluacion,
        fechaDesde: formValues.fechaDesde,
        fechaHasta: formValues.fechaHasta,
        cantidad: +formValues.cantidad || 0,
        idUnidad: +formValues.idUnidad || 0
      }
    }
  });

  const columns = useTabIndicacionHistorialColumns();
  const { firstRowfields, secondRowfields, thirdRowfields } =
  useTabIndicationAddIndicacionFields({
    idEvaluacion,
    isShowingHistory: true
  });

  useEffect(() => {
    if (!historial?.indicacionHistorial?.valorEsperado) return;

    const dataFiltered = applyClientSideFilters(
      historial?.indicacionHistorial?.valorEsperado
    );

    setRows(dataFiltered);
  }, [historial?.indicacionHistorial?.valorEsperado, formValues.insumo]);

  return (
    <CustomDialog
      title="Historial indicación"
      open={open}
      fullWidth
      maxWidth="md"
      onCancel={handleCloseDialog}
      cancelText="Cancelar">
      
      <Box display="flex" flexDirection="column" gap={3}>
        <TabIndicacionFields
          firstRowfields={firstRowfields}
          secondRowfields={[]}
          thirdRowfields={[]}
          formValues={formValues}
          handleChange={handleChange} />
        
        <DataGridGenerico
          columns={columns}
          rows={rows}
          loading={loading}
          toolbar={false}
          hideFooter />
        
      </Box>
    </CustomDialog>);

}